import { h } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { RouterView } from 'vue-router'

export default [
  {
    path: '/:organization?/creatives',
    component: { render: () => h(RouterView) },
    children: [
      {
        path: '',
        name: 'CreativesManagement',
        component: () => import('@/views/creatives/index.vue'),
        meta: {
          title: 'Passport | List of Creatives',
          layout: 'LayoutAuthenticated',
          requiresAuth: true,
        },
      },
    ],
  },
] as RouteRecordRaw[]
